/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardJcbLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 20"
    {...props}
  >
    <path
      fill="url(#card-jcb-logo_svg__a)"
      d="M21.363 11.718h1.53c.044 0 .146-.015.19-.015a.682.682 0 0 0 .539-.684.707.707 0 0 0-.54-.684c-.043-.015-.13-.015-.19-.015h-1.53v1.398Z"
    />
    <path
      fill="url(#card-jcb-logo_svg__b)"
      d="M22.718 2.067a2.651 2.651 0 0 0-2.652 2.65v2.75h3.745c.087 0 .19 0 .262.015.845.044 1.472.48 1.472 1.237 0 .597-.423 1.107-1.21 1.208v.03c.86.058 1.516.538 1.516 1.28 0 .801-.729 1.325-1.69 1.325h-4.11v5.386h3.891a2.651 2.651 0 0 0 2.652-2.65V2.069h-3.876Z"
    />
    <path
      fill="url(#card-jcb-logo_svg__c)"
      d="M23.432 8.894a.62.62 0 0 0-.54-.626c-.028 0-.101-.015-.145-.015h-1.384v1.281h1.384c.044 0 .131 0 .146-.014a.62.62 0 0 0 .539-.626Z"
    />
    <path
      fill="url(#card-jcb-logo_svg__d)"
      d="M8.058 2.067a2.65 2.65 0 0 0-2.652 2.65v6.535c.743.364 1.516.597 2.288.597.918 0 1.413-.553 1.413-1.31V7.453h2.274v3.071c0 1.194-.743 2.169-3.264 2.169-1.53 0-2.725-.335-2.725-.335v5.575h3.89a2.65 2.65 0 0 0 2.653-2.649V2.067H8.058Z"
    />
    <path
      fill="url(#card-jcb-logo_svg__e)"
      d="M15.388 2.067a2.651 2.651 0 0 0-2.652 2.65V8.18c.67-.568 1.836-.932 3.716-.844 1.005.043 2.083.32 2.083.32v1.12a5.048 5.048 0 0 0-2.01-.582c-1.428-.102-2.288.597-2.288 1.82 0 1.237.86 1.936 2.288 1.82.83-.059 1.471-.321 2.01-.583v1.12s-1.063.277-2.083.321c-1.88.087-3.046-.277-3.716-.844v6.113h3.89a2.65 2.65 0 0 0 2.653-2.649V2.067h-3.891Z"
    />
    <defs>
      <linearGradient
        id="card-jcb-logo_svg__a"
        x1={20.063}
        x2={26.612}
        y1={11.021}
        y2={11.021}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873F" />
        <stop offset={0.743} stopColor="#40A737" />
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="card-jcb-logo_svg__b"
        x1={20.063}
        x2={26.612}
        y1={10.001}
        y2={10.001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873F" />
        <stop offset={0.743} stopColor="#40A737" />
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="card-jcb-logo_svg__c"
        x1={20.063}
        x2={26.612}
        y1={8.892}
        y2={8.892}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873F" />
        <stop offset={0.743} stopColor="#40A737" />
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="card-jcb-logo_svg__d"
        x1={5.403}
        x2={12.053}
        y1={10.001}
        y2={10.001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F286F" />
        <stop offset={0.475} stopColor="#004E94" />
        <stop offset={0.826} stopColor="#0066B1" />
        <stop offset={1} stopColor="#006FBC" />
      </linearGradient>
      <linearGradient
        id="card-jcb-logo_svg__e"
        x1={12.698}
        x2={19.157}
        y1={10.001}
        y2={10.001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6C2C2F" />
        <stop offset={0.173} stopColor="#882730" />
        <stop offset={0.573} stopColor="#BE1833" />
        <stop offset={0.859} stopColor="#DC0436" />
        <stop offset={1} stopColor="#E60039" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgCardJcbLogo;
